<vi-checkbox-with-label [checked]="consent"
  [ariaLabel]="inputLabel"
  [label]="label"
  [disabled]="disabled"
  [labelSize]="'12-16'"
  (checkedChange)="toggle($event)">
</vi-checkbox-with-label>
